import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";

/**
 * IncidentDetail page - Redirects to Admin Incident Management
 * 
 * Incident investigation and management has been moved to the Admin Dashboard
 * under the "Incident Management" tab in the DIAGNOSE section.
 * Supervisors no longer handle incident investigation - they only execute
 * assigned tasks through the Supervisor Hub.
 */
const IncidentDetail = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  
  useEffect(() => {
    // Redirect to admin incident management tab
    navigate(`/admin?tab=incident-management`, { replace: true });
  }, [navigate]);
  
  return null;
};

export default IncidentDetail;
